<template>
    <div>
        <div v-if="itens">
            <h5 class="heading-1 mt-2" v-if="!isModal">
                <span>TIMELINE</span>
            </h5>
            <ul class="timeline mt-4" id="timeline">
                <li
                    class="li"
                    :class="{
                        complete: item.concluido && !item.atencao,
                        next: !item.concluido && item.proximo,
                        near: !item.concluido && !item.proximo,
                        notok: item.concluido && item.atencao
                    }"
                    v-for="item in itens"
                    :key="`${item.status}-${item.data}`"
                >
                    <span class="statusSpan">{{ item.status }}</span>
                    <div class="status">
                        <i
                            class="fa"
                            :class="{
                                'timeline-icon fa-exclamation-triangle':
                                    item.concluido && item.atencao,
                                'timeline-icon fa-check':
                                    item.concluido && !item.atencao,
                                'timeline-icon2 fa-hourglass-half':
                                    !item.concluido && item.proximo,
                                'timeline-icon2 fa-times':
                                    !item.concluido && !item.proximo
                            }"
                        ></i>
                    </div>
                    <div class="timestamp">
                        <span class="date" v-if="item.data">{{
                            $moment(item.data, 'DD/MM/YYYY HH:mm').format(
                                'DD/MM/YYYY'
                            )
                        }}</span>
                        <span class="date" v-if="item.data">{{
                            $moment(item.data, 'DD/MM/YYYY HH:mm').format(
                                'HH:mm'
                            )
                        }}</span>
                    </div>
                </li>
            </ul>
        </div>
        <div v-if="!itens">
            <i class="fa fa-circle-o-notch fa-spin fa-2x"></i>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        itens: {
            type: Array,
            default: () => [{}]
        },
        isModal: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {}
    }
}
</script>

<style scoped>
.li {
    transition: all 200ms ease-in;
}
.timeline {
    list-style-type: none;
    display: flex;
    justify-content: center;
    padding-inline-start: 0px !important;
    margin-top: 0px !important;
    margin-bottom: 0px !important;
}

span.date {
    align-items: center;
}

.timestamp {
    margin-bottom: 0px;
    padding: 0px 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    position: relative;
    line-height: 1.5;
    vertical-align: middle;
    font-weight: 500;
}

.status {
    padding: 15px 0px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    border-top: 2px solid #d6dce0;
    position: relative;
    transition: all 200ms ease-in;
}

.statusSpan {
    width: 130px;
    padding: 0px 0px;
    height: 100px;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    text-align: center;
    position: relative;
    line-height: 1.5;
    vertical-align: middle;
    transition: all 200ms ease-in;
    font-weight: 700;
}

.status:before {
    content: '';
    width: 30px;
    height: 30px;
    background-color: white;
    border-radius: 25px;
    border: 1px solid #ddd;
    position: absolute;
    top: -15px;
    left: 40%;
    transition: all 200ms ease-in;
    align-items: center;
}

.li.complete .status {
    border-top: 2px solid #66dc71;
}

.li.complete .status:before {
    background-color: #66dc71;
    border: none;
    transition: all 200ms ease-in;
}

.li.complete .status i {
    position: absolute;
    top: -10px;
    left: 42%;
    justify-content: center;
}

.li.complete .statusSpan {
    color: #666666;
}

.li.next .status {
    border-top: 2px solid #f6ab21;
}

.li.next .status:before {
    background-color: #f6ab21;
    border: none;
    transition: all 200ms ease-in;
}

.li.next .status i {
    position: absolute;
    top: -10px;
    left: 43.5%;
    justify-content: center;
}

.li.next .statusSpan {
    color: #666666;
}

.li.near .status {
    border-top: 2px solid #666666;
}

.li.near .status:before {
    background-color: #666666;
    border: none;
    transition: all 200ms ease-in;
}

.li.near .status i {
    position: absolute;
    top: -10px;
    left: 48%;
    justify-content: center;
}

.li.near .statusSpan {
    color: #666666;
}

.li.notok .status {
    border-top: 2px solid #d60000;
}

.li.notok .status:before {
    background-color: #d60000;
    border: none;
    transition: all 200ms ease-in;
}

.li.notok .status i {
    position: absolute;
    top: -10px;
    left: 42%;
    justify-content: center;
}

.li.notok .statusSpan {
    color: #666666;
}

.timeline-icon {
    top: -16% !important;
    left: 47% !important;
}

.timeline-icon2 {
    top: -16% !important;
    left: 48% !important;
}

@media (min-device-width: 320px) and (max-device-width: 700px) {
    .timeline {
        list-style-type: none;
        display: block;
    }

    .li {
        transition: all 200ms ease-in;
        display: flex;
        width: inherit;
    }

    .timestamp {
        width: 100px;
    }

    .status:before {
        left: -8%;
        top: 30%;
        transition: all 200ms ease-in;
    }
}

/* html,
body {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    font-family: 'Titillium Web', sans serif;
    color: #758d96;
} */
</style>